class LocalizationService {
    get languages() {
        return cf.localization.languages;
    }

    get currentLanguage() {
        return cf.localization.currentLanguage;
    }

    localize(key, sourceName) {
        return cf.localization.localize(key, sourceName);
    }

    getSource(sourceName) {
        return cf.localization.getSource(sourceName);
    }
}

export default new LocalizationService();
